import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ASC_MONO_LOGO from '../../../assets/asc-monogram.jpg'
import DialogHelper from '../../../helper/DialogHelper'
import { kioskLogin } from '../../../services/KioskAuthService'

export default function KioskLoginPage() {
    const [kioskCode, setKioskCode] = useState('')
    const [secret, setSecret] = useState('')
    const [loading, setLoading] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [dialogMessage, setDialogMessage] = useState('')
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        const result = await kioskLogin({ kioskCode, secret })

        if (result.error) {
            setDialogMessage(result.error)
            setIsOpen(true)
            setLoading(false)
        } else {
            navigate('/kiosk')
        }
    }

    return (
        <div className="flex items-center justify-center min-h-screen w-full bg-neutral-50 px-4 py-10">
            <div className="w-full max-w-sm">
                <div className="text-center mb-10">
                    <img src={ASC_MONO_LOGO} alt="ASC Logo" className="h-12 mx-auto mb-6" />
                    <h2 className="text-xl font-medium text-gray-900">Kiosk Activation</h2>
                    <p className="text-gray-400 text-sm mt-1">Sign in this device with its kiosk code and secret</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-3">
                    <input
                        type="text"
                        value={kioskCode}
                        onChange={(e) => setKioskCode(e.target.value)}
                        placeholder="Kiosk Code (e.g. KIOSK-001)"
                        required
                        className="input-field text-lg py-3"
                    />

                    <input
                        type="password"
                        value={secret}
                        onChange={(e) => setSecret(e.target.value)}
                        placeholder="Kiosk Secret"
                        required
                        className="input-field text-lg py-3"
                    />

                    <button type="submit" disabled={loading} className="btn-primary w-full text-lg py-4 mt-6">
                        {loading ? 'Activating...' : 'Activate Kiosk'}
                    </button>
                </form>
            </div>

            <DialogHelper
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title="Kiosk Login Failed"
                message={dialogMessage}
            />
        </div>
    )
}
